import React, { useState, useEffect } from 'react';
import HomeFilter from './HomeFilter';

const DeFi = ({ currentPage, setCurrentPage, totalPages, setTotalPages, loading, setLoading }) => {
  const [coins, setCoins] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDeFiCoins = async () => {
      setLoading(true);
      const query = new URLSearchParams({ page_number: currentPage }).toString();
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/coins/defi?${query}`);
        
        if (!response.ok) {
          throw new Error(`API request failed with status ${response.status}`);
        }
        
        const data = await response.json();
        
        if (data.error) {
          throw new Error(data.error);
        }
        
        // Format the data for display
        const formattedData = data.map(coin => ({
          ...coin,
          current_price: coin.current_price.toLocaleString('en-US', {
            //style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: coin.current_price < 1 ? 6 : 2
          }),
          market_cap: coin.market_cap.toLocaleString('en-US', {
            //style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0
          }),
          total_volume: coin.total_volume.toLocaleString('en-US', {
            //style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0
          })
        }));
        
        setCoins(formattedData);
        setError(null);
      } catch (err) {
        console.error('Error fetching DeFi coins:', err);
        setError('Failed to load DeFi data. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchDeFiCoins();
    
    // Refresh data every 5 minutes
    const interval = setInterval(fetchDeFiCoins, 300000);
    return () => clearInterval(interval);
  }, [currentPage]);

  const handlePageChange = (direction) => {
    console.log(direction);
    setCurrentPage((prevPage) => {
      if (direction === 'prev') {
        return Math.max(prevPage - 1, 1); // Minimum page is 1
      } else if (direction === 'next') {
        return Math.min(prevPage + 1, totalPages); // Maximum page is totalPages
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
      return prevPage;
    });
  };


  if (error) return <div className="text-center py-10 text-red-500">{error}</div>;

  return (
      <div className="container mx-auto px-4 py-8">
        <HomeFilter 
          coins={coins} 
          showTimeframes={true}  // Show 1h/24h/7d changes
        />
        <div className="btn_mainsec">
          <button
            className="btn_style"
            onClick={() => handlePageChange('prev')}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          <button
            className="btn_style"
            onClick={() => handlePageChange('next')}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>
  );
};

export default DeFi;